/* eslint-disable indent */
import React, { useEffect } from "react";
import styles from "../EditableTag.module.css";
import Seta from "../../../Assets/images/seta.png";
import { useEditableTag } from "./EditableTagBase";
import { ToolbarComponent, CanvasComponent } from "./SharedComponents";

const EditableTag10x10 = ({ initialData, doubleTag = false }) => {
	const canvasSize = { width: 283.46, height: 283.46 };
	const {
		canvasRef,
		elements,
		setElements,
		setInitialElements,
		selectedElement,
		setSelectedElement,
		zoom,
		handleMouseDown,
		handleElementClick,
		handleMouseMove,
		handleMouseUp,
		updateElementProperty,
		deleteElement,
		handleZoomIn,
		handleZoomOut,
		handleZoomReset,
		exportToPDF,
		printPDF,
		resetToInitialState
	} = useEditableTag(canvasSize);

	useEffect(() => {
		if (initialData)
			initializeElements(initialData);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialData]);

	const initializeElements = (data) => {
		const newElements = [];
		let idCounter = Date.now();

		// Layout 10x10: row com lado esquerdo e lado direito
		const leftSideX = 20;
		const leftSideWidth = 160;

		// Título (cultura) - centralizado
		if (data.culture) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: data.culture,
				x: leftSideX + 30,
				y: 20,
				width: 100,
				height: 24,
				fontSize: 13,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "center",
				textTransform: "uppercase",
				overflow: "visible"
			});
		}

		// Peso Líquido Mínimo
		if (data.weight) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: `Peso Líquido Mínimo: ${data.weight}`,
				x: leftSideX,
				y: 50,
				width: leftSideWidth,
				height: 15,
				fontSize: 9,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
		}

		// Código de Rastreio
		if (data.trackingCode) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: `Código de Rastreio: ${data.trackingCode}`,
				x: leftSideX,
				y: 72,
				width: leftSideWidth,
				height: 10,
				fontSize: 9,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.3,
				overflow: "visible"
			});
		}

		// Produtor
		if (data.producer) {
			const producerInfo = `Distribuído por: ${data.producer.name}\n${data.producer.document}\n${data.producer.address}`;
			newElements.push({
				id: idCounter++,
				type: "text",
				content: producerInfo,
				x: leftSideX,
				y: 104,
				width: leftSideWidth,
				height: 13,
				fontSize: 9,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
		}

		// Distribuidor
		let currentY = 139;
		if (data.distributor) {
			const distributorInfo = `Destino: ${data.distributor.name}\n${data.distributor.document}\n${data.distributor.address}`;
			newElements.push({
				id: idCounter++,
				type: "text",
				content: distributorInfo,
				x: leftSideX,
				y: currentY,
				width: leftSideWidth,
				height: 13,
				fontSize: 9,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
			currentY += 17;
		}

		// Datas
		if (data.dates) {
			let dateText = "";
			if (data.dates.packaging) dateText += `Data de Embalagem: ${data.dates.packaging}\n`;
			if (data.dates.delivery) dateText += `Data de Entrega: ${data.dates.delivery}\n`;
			if (data.dates.expiry) dateText += `Data de Validade: ${data.dates.expiry}`;

			const maxHeight = 263 - currentY - 1;

			newElements.push({
				id: idCounter++,
				type: "text",
				content: dateText,
				x: leftSideX,
				y: currentY,
				width: leftSideWidth,
				height: maxHeight,
				fontSize: 9,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
		}

		// Lado direito - QR Code e código de barras (centralizados verticalmente com margem superior)
		const rightSideX = 193;

		// Textos acima do QR Code
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "CONHEÇA ORIGEM",
			x: rightSideX,
			y: 60,
			width: 90,
			height: 8,
			fontSize: 5,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center"
		});

		newElements.push({
			id: idCounter++,
			type: "text",
			content: "DESTE PRODUTO",
			x: rightSideX,
			y: 68,
			width: 90,
			height: 8,
			fontSize: 5,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center"
		});

		// QR Code
		if (data.qrCode) {
			newElements.push({
				id: idCounter++,
				type: "image",
				content: data.qrCode,
				x: rightSideX,
				y: 80,
				width: 90,
				height: 90
			});
		}

		// Código de Barras
		if (data.barCode) {
			newElements.push({
				id: idCounter++,
				type: "image",
				content: data.barCode,
				x: rightSideX,
				y: 180,
				width: 90,
				height: 35,
				objectFit: "fill"
			});
		}

		// Texto "POR: SISAGRI"
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "POR: SISAGRI",
			x: rightSideX,
			y: 215,
			width: 90,
			height: 8,
			fontSize: 5,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center"
		});

		// Footer
		const footerY = 263;
		const footerHeight = 15;

		// Fundo preto do footer
		newElements.push({
			id: idCounter++,
			type: "footer-background",
			content: "",
			x: 0,
			y: footerY,
			width: canvasSize.width,
			height: footerHeight,
			backgroundColor: "black",
			isFooterElement: true,
			zIndex: -1
		});

		// Layout do footer
		const footerPadding = 8;
		const arrowWidth = 10;
		const spacing = 8;
		const totalArrows = 3 * arrowWidth;
		const totalSpacing = 4 * spacing;
		const availableForTexts = canvasSize.width - totalArrows - totalSpacing - (2 * footerPadding);
		const textWidth = availableForTexts / 2;

		let currentX = footerPadding;

		// Seta 1
		newElements.push({
			id: idCounter++,
			type: "image",
			content: Seta,
			x: currentX,
			y: footerY + 3,
			width: arrowWidth,
			height: 10,
			isFooterElement: true
		});
		currentX += arrowWidth + spacing;

		// Texto 1
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "PRODUTO COM ORIGEM RASTREADA",
			x: currentX,
			y: footerY + 3,
			width: textWidth,
			height: 10,
			fontSize: 6,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			color: "white",
			lineHeight: 1.0,
			whiteSpace: "nowrap",
			overflow: "visible",
			isFooterElement: true
		});
		currentX += textWidth + spacing;

		// Seta 2 (invertida)
		newElements.push({
			id: idCounter++,
			type: "image",
			content: Seta,
			x: currentX,
			y: footerY + 3,
			width: arrowWidth,
			height: 10,
			transform: "scaleX(-1)",
			isFooterElement: true
		});
		currentX += arrowWidth + spacing;

		// Texto 2
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "https://www.sisagri.com.br",
			x: currentX,
			y: footerY + 3,
			width: textWidth,
			height: 10,
			fontSize: 6,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			color: "white",
			lineHeight: 1.0,
			whiteSpace: "nowrap",
			overflow: "visible",
			isFooterElement: true
		});
		currentX += textWidth + spacing;

		// Seta 3 (invertida)
		newElements.push({
			id: idCounter++,
			type: "image",
			content: Seta,
			x: currentX,
			y: footerY + 3,
			width: arrowWidth,
			height: 10,
			transform: "scaleX(-1)",
			isFooterElement: true
		});

		setElements(newElements);
		setInitialElements(JSON.parse(JSON.stringify(newElements)));
	};

	const selectedElementData = elements.find(el => el.id === selectedElement);

	return (
		<div className={styles.editorContainer}>
			<ToolbarComponent
				selectedElementData={selectedElementData}
				updateElementProperty={updateElementProperty}
				handleZoomOut={handleZoomOut}
				handleZoomIn={handleZoomIn}
				handleZoomReset={handleZoomReset}
				zoom={zoom}
				exportToPDF={() => exportToPDF("10x10", doubleTag)}
				printPDF={() => printPDF(doubleTag)}
				resetToInitialState={resetToInitialState}
			/>

			<CanvasComponent
				canvasRef={canvasRef}
				canvasSize={canvasSize}
				zoom={zoom}
				elements={elements}
				selectedElement={selectedElement}
				setSelectedElement={setSelectedElement}
				handleMouseMove={handleMouseMove}
				handleMouseUp={handleMouseUp}
				handleMouseDown={handleMouseDown}
				handleElementClick={handleElementClick}
				deleteElement={deleteElement}
			/>
		</div>
	);
};

export default EditableTag10x10;
